import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M11.599 5.5h2.288a.46.46 0 0 0 .426-.295.49.49 0 0 0-.1-.52l-2.289-2.37a.45.45 0 0 0-.501-.103.48.48 0 0 0-.285.44v2.371c0 .264.206.477.46.477M6.31.5V.477A.47.47 0 0 0 5.85 0H2.43C1.641 0 1 .664 1 1.483v11.535c0 .818.64 1.482 1.431 1.482h1.466V2.983C3.897 1.614 4.972.5 6.293.5z" }),
      _createElementVNode("path", { d: "M11.624 11H8.258a.49.49 0 0 1-.483-.5c0-.276.216-.5.483-.5h3.366c.267 0 .483.224.483.5s-.216.5-.483.5m-.47 2h-2.44a.49.49 0 0 1-.482-.5c0-.276.215-.5.483-.5h2.44c.266 0 .482.224.482.5s-.216.5-.482.5m3.384-6.5H11.1c-.512 0-.928-.43-.928-.961V1.977a.47.47 0 0 0-.46-.477H6.293c-.79 0-1.431.664-1.431 1.483v11.535c0 .818.64 1.482 1.431 1.482h7.276c.79 0 1.43-.664 1.43-1.482V6.977a.47.47 0 0 0-.46-.477" })
    ], -1)
  ]))]))
}
export default { render: render }